import React from "react";
import Marquee from "react-fast-marquee";
import * as Icon from "@phosphor-icons/react/dist/ssr";

interface Props {
  props: string;
  textColor: string;
  bgLine: string;
}

const BannerTop: React.FC<Props> = ({ props, textColor, bgLine }) => {
  return (
    <div className="flex justify-end">
      <div
        className={`banner-top flex items-center ${props} 2xl:w-[98%] xl:w-[98%] lg:w-[98%] max-md:w-full 2xl:rounded-tl-xl xl:rounded-t-xl  lg:rounded-t-xl max-md:rounded-tl-none`}
      >
        <div
          className="fx-reveal md:w-2/12 2xl:flex xl:flex lg:flex hidden items-center justify-center gap-3 text-center text-white border-r"
        >
          <Icon.List size={16} className="text-white font-bold" />
          <h3 className="font-bold">All Categories</h3>
        </div>
        <Marquee className="menu-slid fx-reveal">
          <div className={`text-button-uppercase px-8 ${textColor}`}>
            Obtenez 10% de réduction sur les articles sélectionnés
          </div>
          <div className={`line w-8 h-px ${bgLine}`}></div>
          <div className={`text-button-uppercase px-8 ${textColor}`}>
            Les nouveaux clients économisent 10%
          </div>
          <div className={`line w-8 h-px ${bgLine}`}></div>
          <div className={`text-button-uppercase px-8 ${textColor}`}>
            10% de réduction sur les maillots de bain
          </div>
          <div className={`line w-8 h-px ${bgLine}`}></div>
          <div className={`text-button-uppercase px-8 ${textColor}`}>
            Livraison gratuite pour toutes les commandes de plus de 750 MAD
          </div>
          <div className={`line w-8 h-px ${bgLine}`}></div>
          <div className={`text-button-uppercase px-8 ${textColor}`}>
            10% de réduction sur tous les indispensables de l'été !
          </div>
          <div className={`line w-8 h-px ${bgLine}`}></div>
          <div className={`text-button-uppercase px-8 ${textColor}`}>
            Préparez-vous pour l'été : 10% de réduction sur les maillots de bain
          </div>
          <div className={`line w-8 h-px ${bgLine}`}></div>
          <div className={`text-button-uppercase px-8 ${textColor}`}>
            10% de réduction sur tous les produits
          </div>
          <div className={`line w-8 h-px ${bgLine}`}></div>
        </Marquee>
      </div>
    </div>
  );
};

export default BannerTop;
